import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons'
import { faExclamationCircle as faExclamationCircleSolid } from '@fortawesome/pro-solid-svg-icons'

import { Box, HoverHintWrapper, Text } from '@domain-group/suit-theme'

import type { CampaignQuoteModel } from '@models/types'

type ArrayElement<T> = T extends (infer U)[] ? U : never;

interface CampaignQuoteItemToolTipProps {
  boxProps?: { [key: string]: any },
  iconColor?: string,
  invalidPrice: ArrayElement<CampaignQuoteModel['invalidItems']> | undefined,
  fontSize?: string,
  solidIcon?: boolean,
}

const CampaignQuoteItemToolTip = (props: CampaignQuoteItemToolTipProps) => {
  const {
    boxProps, iconColor = 'orange', invalidPrice, fontSize = 'small', solidIcon,
  } = props

  const currentPriceIsZero = invalidPrice?.current_price === 0

  return (
    <HoverHintWrapper
      width={16}
      boxProps={{ marginLeft: 'small' }}
      hintComponent={!!invalidPrice && (
        <HoverHintWrapper.Hint
          boxProps={{ ...boxProps }}
        >
          {!currentPriceIsZero && (
            <Box flexDirection="column" padding="medium">
              <Text color="faintGrey" fontSize={fontSize}>Update the price to match the price list</Text>

              <Box justifyContent="space-between" marginTop="medium">
                <Text color="white" fontSize={fontSize}>Old Price</Text>

                <Text color="white" fontSize={fontSize}>{invalidPrice.original_price}</Text>
              </Box>

              <Box justifyContent="space-between" marginTop="medium">
                <Text color="white" fontSize={fontSize}>New Price</Text>

                <Text color="white" fontSize={fontSize}>{invalidPrice.current_price}</Text>
              </Box>

              <Box justifyContent="space-between" marginTop="medium">
                <Text color="white" fontSize={fontSize}>Difference</Text>

                <Text color="white" fontSize={fontSize}>{invalidPrice.difference}</Text>
              </Box>
            </Box>
          )}

          {currentPriceIsZero && (
            <Box padding="medium">
              <Text color="faintGrey" fontSize={fontSize}>
                This quantity or option may not be available on current price list.
              </Text>
            </Box>
          )}
        </HoverHintWrapper.Hint>
      )}
    >
      <FontAwesomeIcon icon={solidIcon ? faExclamationCircleSolid : faExclamationCircle} style={{ color: iconColor }} />
    </HoverHintWrapper>
  )
}

export default CampaignQuoteItemToolTip
